import script from "./HrActionMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./HrActionMenu.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'directives', {ClosePopup});
